export const isBilledFolio = (folio) =>
  !!folio.Selected || !!folio.InvNo || folio.TotalAmt !== folio.Unpaid;

export const canVoidFolio = (folio, allowVoidBilledFolio = false) =>
  folio.PfmStatus !== "Void" &&
  (!isBilledFolio(folio) || allowVoidBilledFolio === true);
